/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import {Container, Row, Col } from "reactstrap";

class AuthFooter extends React.Component {
  render() {
    return (
        <div className='footer background-primary mt-5'>
            <Container>
                <Row className="align-items-center justify-content-lg-between">
                  <Col className='white-color' lg="12">
                  <div><b>Der Service wird betrieben von:</b></div>
                    <div>e.less Systems GmbH | Karl-Drais-Straße 4B | 86159 Augsburg</div>
                    <div>AG Augsburg | HRB 31137 | Geschäftsführer: A. Schießl, T. Athenstaedt, A. Banerjee</div>
                  </Col>
                </Row>
            </Container>
        </div>
    );
  }
}

export default AuthFooter;
